import Cookies from 'js-cookie';
import toast from "react-hot-toast";
import { axiosInstance } from '../lib/axios';


const getCategoryapi = async () => {
    try {
        const res = await axiosInstance.get(`/category/featured`)
        return res.data.data
    } catch (err) {
        console.log(err.response?.data?.message);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

const getCategoryInPriceRangeFunction = async (min, max, categoryId) => {
    try {
        const params = new URLSearchParams();
        params.append('min', min);
        params.append('max', max);
        params.append('categoryID', categoryId);

        const res = await axiosInstance.get(`/product/price-range-by-category?${params.toString()}`)
        // toast.success("Successfully fetched!");
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

export {
    getCategoryapi,
    getCategoryInPriceRangeFunction
}